<template>
    <div class="cards-wrap">
        <div class="top-back">
            <span class="back-arrow" @click="$router.back()"></span>
            Cards
        </div>
        
        <div class="card-list-wrap">
            
            <div class="tab">
                <div :class="tabList[0]?'tab-item tab-active':'tab-item'" @click="changeTab(0)">{{ $t('未使用') }}</div>
                <div :class="tabList[1]?'tab-item tab-active':'tab-item'" @click="changeTab(1)">{{ $t('使用中') }}</div>
                <div :class="tabList[2]?'tab-item tab-active':'tab-item'" @click="changeTab(2)">{{ $t('已过期') }}</div>
            </div>
            
            <div class="card-list">
                
                <div v-if="tabList[0]" v-for="(item,key) in unuseCardList" class="card-item">
                    <div class="card-order">{{ $t('卡片序号') }} <b>{{ item.create_time + item.id }}</b></div>
                    <div class="card-name">{{ $t('类型') }}: <b>{{ $t(item.name) }}</b></div>
                    <div class="card-name">{{ $t('力度') }}: <b><span v-if="item.type != 3">+</span>{{ item.rate }}<span
                        v-if="item.type == 1">%</span></b>
                    </div>
                    <div v-if="item.type != 4 && item.type != 2" class="card-name">{{ $t('时效') }}: <b>{{
                            item.buff_time
                        }} {{ $t('小时') }}</b></div>
                    <div class="card-name">{{ $t('来源') }}: <b>{{ $t(item.fromStr) }}</b></div>
                    <div class="card-name">{{ $t('有效至') }}: <b>{{ item.validate }}</b></div>
                    <div class="btns">
                        <div class="use-btn" @click="useCard(item.bid)">{{ $t('使用') }}</div>
                        <div class="send-btn" @click="show_tc = true;gobal_buff_id = item.bid">{{ $t('赠送') }}</div>
                    </div>
                
                </div>
                
                <div v-if="tabList[1]" v-for="(item,key) in usingCardList" class="card-item">
                    <div class="card-order">{{ $t('卡片序号') }} <b>{{ item.create_time + item.id }}</b></div>
                    <div class="card-name">{{ $t('类型') }}: <b>{{ $t(item.name) }}</b></div>
                    <div class="card-name">{{ $t('力度') }}: <b> <span v-if="item.type != 3">+</span>{{ item.rate }}<span v-if="item.type == 1">%</span></b></div>
                    <div v-if="item.type != 4 && item.type != 2" class="card-name">{{ $t('时效') }}:
                        <b>{{ item.buff_time }}{{ $t('小时') }}</b></div>
                    <div class="card-name">{{ $t('来源') }}: <b>{{ $t(item.fromStr) }}</b></div>
                    <div class="card-name">{{ $t('开始时间') }}: <b>{{ item.start_time_str }}</b></div>
                    <div class="card-name">{{ $t('失效时间') }}: <b>{{ item.validate }}</b></div>
                </div>
                
                <div v-if="tabList[2]" v-for="(item,key) in usedCardList" class="card-item">
                    <div class="card-order">{{ $t('卡片序号') }}: <b>{{ item.create_time + item.id }}</b></div>
                    <div class="card-name">{{ $t('类型') }}: <b>{{ $t(item.name) }}</b></div>
                    <div class="card-name">{{ $t('力度') }}: <b><span v-if="item.type != 3">+</span>{{ item.rate }}<span v-if="item.type == 1">%</span></b>
                    </div>
                    <div v-if="item.type != 4 && item.type != 2" class="card-name">{{ $t('时效') }}: <b>{{
                            item.buff_time
                        }}{{ $t('小时') }}</b></div>
                    <div class="card-name">{{ $t('来源') }}: <b>{{ $t(item.fromStr) }}</b></div>
                    <div class="card-name">{{ $t('有效至') }}: <b>{{ item.validate }}</b></div>
                </div>
            </div>
        </div>
        
        
        <van-dialog v-model="show_tc"
                    :confirmButtonText="$t('utils.confirm')"
                    :confirmButtonColor="'green'"
                    :showCancelButton="true"
                    :cancelButtonText="$t('utils.cancel')"
                    :cancelButtonColor="'red'"
                    :beforeClose="isSend"
                    :title="$t('已过期')"
        >
            <div class="send-wrap">
                <div class="left91">+57</div>
                <input type="text" class="send-input" v-model="phone" :placeholder="$t('已过期')">
            </div>
        
        </van-dialog>
    
    </div>
</template>

<script>
import Vue from 'vue';
import {
    CountDown,
    Checkbox,
    RadioGroup,
    Icon,
    Radio, Dialog
} from 'vant';
import {
    jsBridge
} from '../../utils/jsbridge-mini.js';
import Fetch from '../../utils/fetch'
import Api from "../../interface/index";
import loading from "@/store/loading";

Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(CountDown).use(Checkbox).use(Icon).use(Dialog);
export default {
    name: "mycards",
    data() {
        return {
            lang: this.$i18n.locale || "zh_cn",
            active: 0,
            tabList: [1, 0, 0],
            cardList: [],
            unuseCardList: [],
            usingCardList: [],
            usedCardList: [],
            show_tc: false,
            gobal_buff_id: 0,
            phone: "",
        }
    },
    mounted() {
    },
    created() {
        this.$parent.footer('user', false);
        this.init();
    },
    methods: {
        //获取用户的卡包
        init() {
            Fetch('/buff/getBuffList').then((r) => {
                //console.log(r);
                this.cardList = r.data;
                this.cardList.forEach(item => {
                    //console.log(item);
                    if (item.bstatus == 0) {
                        this.unuseCardList.push(item);
                    } else if (item.bstatus == 1) {
                        this.usingCardList.push(item);
                    } else {
                        this.usedCardList.push(item);
                    }
                });
            });
        },
        changeTab(index) {
            this.tabList = [0, 0, 0];
            this.tabList[index] = 1;
        },
        //使用Buff
        useCard(bid) {
            Dialog.alert({
                //title:"Card Info",
                message: this.$t("确定使用这个卡片吗"),
                confirmButtonText: window.vm.$i18n.t('utils.confirm'),
                showCancelButton: true,
                cancelButtonText: window.vm.$i18n.t('utils.cancel'),
            }).then(res => {
                //console.log(res);
                //确定使用
                Fetch('/buff/useBuff', {buff_id: bid}).then((r) => {
                    if (r.code == 1) {
                        this.$toast({
                            background: "#07c160",
                            message: r.info[this.lang],
                        });
                        setTimeout(() => {
                            this.$router.go(0)
                        }, 500);
                    }
                });
                
            }).catch(e => {
                //取消使用
                //console.log(e);
            });
        },
        
        isSend(action, done) {
            //console.log(action);
            if (action == 'confirm') {
                Fetch('/buff/sendBuff', {buff_id: this.gobal_buff_id, phone: this.phone}).then((r) => {
                    if (r.code == 1) {
                        this.$toast({
                            background: "#07c160",
                            message: r.info[this.lang],
                        });
                        done();
                        setTimeout(() => {
                            this.$router.go(0)
                        }, 500);
                    } else {
                        done();
                    }
                });
            } else {
                done();
            }
        },
    }
}
</script>

<style scoped lang="less">
.left91 {
    float: left;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #7e7e7e;
    color: #d0d0d0;
    width: 1rem;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    margin-left: 20%;
    font-size: 0.4rem;
}

.send-wrap {
    margin: 25px 0;
    height: 40px;
    width: 100%;
}

.send-input {
    width: 50%;
    float: left;
    height: 30px;
    border: 1px solid #b4b3b3;
    font-size: 0.4rem;
    border-left: none;
    text-indent: 5px;
}

.btns {
    height: 40px;
    border-top: 1px solid #3A4A7C;
    color: white;
    //padding: 15px 0;
    padding-top: 3px;
    font-size: 0.35rem;
    width: 95%;
    margin: 0 auto 8px;
    font-family: Arial-BoldMT;
}

.send-btn {
    width: 100px;
    height: 30px;
    background: #52BE22;
    text-align: center;
    color: white;
    line-height: 30px;
    border-radius: 15px;
    float: right;
    margin-right: 15px;
}

.use-btn {
    width: 100px;
    height: 30px;
    background: #EB5678;
    text-align: center;
    color: white;
    line-height: 30px;
    border-radius: 15px;
    float: right;
    margin-right: 15px;
}

.card-name {
    padding: 8px 0;
    text-indent: 10px;
    color: white;
    font-family: ArialMT;
    font-size: 0.35rem;
}

.card-order {
    //height: 30px;
    //line-height: 30px;
    //text-indent: 10px;
    border-bottom: 1px solid #3A4A7C;
    color: white;
    padding: 15px 0;
    font-size: 0.35rem;
    width: 95%;
    margin: 0 auto 8px;
    font-family: Arial-BoldMT;
    
}

.card-item {
    //height: 170px;
    width: 95%;
    margin: 15px auto;
    //background: rgba(28, 24, 27, 0.86);
    //background: #2B3864;
    background: #2B3864;
    border-radius: 8px;
    box-sizing: border-box;
    //padding: 10px;
    position: relative;
    height: auto;
}

.tab-active {
    //background: #07c160;
    color: #FDD5AD !important;
    border-bottom: 1px solid #FDD5AD;
}

.tab {
    width: 100%;
    display: flex;
    //background: red;
    height: 40px;
    box-sizing: border-box;
    border-bottom: 1px solid #304869;
}

.tab-item {
    flex: 33.33%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    box-sizing: border-box;
    color: #9BA3C8;
    font-size: 0.35rem;
}

.tab-item:nth-child(1) {
    //border-right: 1px solid #304869;
}

.tab-item:nth-child(2) {
    //border-right: 1px solid #304869;
}

.top-back {
    height: 50px;
    width: 100%;
    //background: #3d96ff;
    position: relative;
    color: white;
    font-size: 0.6rem;
    text-align: center;
    line-height: 50px;
    text-indent: -50px;
}

.back-arrow {
    float: left;
    width: 20px;
    height: 20px;
    background: url(../../views/images/item/back.png) no-repeat center center;
    background-size: auto 100%;
    margin: 12px 0 0 8px;
}
</style>